.themeToggle {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  width: 32px;
  height: 32px;
  border-radius: var(--radius);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.themeToggle:hover {
  color: var(--text-primary);
  border-color: var(--text-secondary);
  background: var(--bg-primary);
}